<template>
  <div class="credit-card-details-form">
    <loader v-if="asyncLoading" class="cc-loader"/>
    <div v-else >
      <div v-if="!paymeLoadingError">
        <div class="title">פרטי הכרטיס</div>
        <card-number-field/>
        <div class="row">
          <expiration-field class="expiration"/>
          <div class="spacer"></div>
          <cvv-field/>
        </div>
        <social-id/>
      </div>
      <div v-else class="init-error">
        <div>נראה שיש בעיה עם מערכת התשלום</div>
        <div>אפשר לרענן את העמוד ולנסות שוב</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Loader from '@/base-components/Loader';
import CardNumberField from '../subscription/components/credit-card-fields/CardNumber.vue';
import ExpirationField from '../subscription/components/credit-card-fields/Expiration.vue';
import CvvField from '../subscription/components/credit-card-fields/CVV.vue';
import SocialId from '../subscription/components/credit-card-fields/SocialId.vue';

export default {
  name: 'CreditCardDetailsForm',
  components: {
    Loader,
    CardNumberField,
    ExpirationField,
    CvvField,
    SocialId,
  },
  data() {
    return {
      asyncLoading: true,
      paymeLoadingError: false,
    };
  },
  async created() {
    await this.initPaymeInterface();
    if (!this.fieldsInstance) {
      this.paymeLoadingError = true;
      this.$emit('init-failed');
    }
    this.asyncLoading = false;
  },
  computed: {
    ...mapState('subscription', ['fieldsInstance']),
  },
  methods: {
    ...mapActions('subscription', ['initPaymeInterface']),
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.expiration {
  margin-left: 15px;
}
.cc-loader {
  margin-bottom: 30px;
}

.init-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  color: $riseup_danger_red;

  div {
    padding: 5px;
  }
}
</style>
